import gql from 'graphql-tag';
export const sendSmsTwoFaMutation = gql `
  mutation SendSmsVerificationCode($record: SmsVerificationCodeRecord!) {
    sendSmsVerificationCode(record: $record)
  }
`;
export const loginWithSmsTwoFaMutation = gql `
  mutation LoginSms2FA($record: TwoFactorLoginRecord!) {
    loginSms2FA(record: $record) {
      accessToken
    }
  }
`;
export const sendEmailVerificationCodeMutation = gql `
  mutation SendEmailVerificationCode($record: EmailVerificationCodeRecord!) {
    sendEmailVerificationCode(record: $record)
  }
`;
export const loginEmail2FAMutation = gql `
  mutation LoginEmail2FA($record: TwoFactorLoginRecord!) {
    loginEmail2FA(record: $record) {
      accessToken
    }
  }
`;
export const loginWithG2FaMutation = gql `
  mutation LoginGoogle2FA($record: TwoFactorLoginRecord!) {
    loginGoogle2FA(record: $record) {
      accessToken
    }
  }
`;
export const turnOffSms2FaMutation = gql `
  mutation TurnOffSms2FA($record: ToggleSms2FARecord!) {
    turnOffSms2FA(record: $record)
  }
`;
export const turnOnSms2FaMutation = gql `
  mutation TurnOnSms2FA($record: ToggleSms2FARecord!) {
    turnOnSms2FA(record: $record)
  }
`;
//# sourceMappingURL=twoFa.js.map